import React, { useState } from "react";
import "../components/InformacionDeInteres.css";
import Camara from "../assets/img/logonuevo1536x2131.png";
import Wca from "../assets/img/Logos_AsociadosWCA.png";
import Adex from "../assets/img/LOGOADEXAZUL.png";
import Ccl from "../assets/img/ccl2.jpg";
import Footer from "../components/Footer";
import Preguntas from "../assets/img/preguntasperu.jpg";
import ManualPrevencion from "../assets/archivos/MANUAL PARA LA PREVENCIÓN DEL LAVADO DE ACTIVOS .pdf";
import ManualPrevencionDelitos from "../assets/archivos/MANUAL PARA LA PREVENCIÓN DE DELITOS - PRIMUS PERÚ.pdf";

const InformacionDeInteres = () => {
  const [subActiveIndex, setSubActiveIndex] = useState(null);

  const toggleSubAccordion = (index) => {
    setSubActiveIndex(subActiveIndex === index ? null : index);
  };
  return (
    <div>
      <div className="bannerInformacion">
        <h1 className="bannerInformacion-title">Información de Interés</h1>
      </div>
      <div className="somosMiembros">
        <h2>Somos miembros de:</h2>
      </div>
      <div className="styled-divInfo">
        <div className="image-containerInfo">
          <a href="https://camaraperuchile.org/">
            <img src={Camara} alt="Imagen 1" />
          </a>
        </div>
        <div className="image-containerInfo">
          <a href="https://worldcomplianceassociation.com/">
            <img src={Wca} alt="Imagen 2" />
          </a>
        </div>
        <div className="image-containerInfo">
          <a href="https://www.adexperu.org.pe/">
            <img src={Adex} alt="Imagen 3" />
          </a>
        </div>
        <div className="image-containerInfo">
          <a href="https://www.camaralima.org.pe/">
            <img src={Ccl} alt="Imagen 3" />
          </a>
        </div>
      </div>
      <div className="registroEmpresas">
        <p>
          PRIMUS CAPITAL S.A.C. Se encuentra inscrita el “Registro de Empresas
          de Factoring no comprendidas en el ámbito de la ley general” de la
          SBS. N° 000017261
        </p>
      </div>
      {/* ------PREGUNTAS FRECUENTES------   */}
      <div className="preguntas">
        <h1 className="preguntas-title">Preguntas Frecuentes</h1>
        <div className="preguntas-content-container">
          <div className="preguntas-text-container">
            <div className="sub-accordionPreguntas">
              <div className="accordion-itemPreguntas" style={{ width: "90%" }}>
                <div
                  className="accordion-titlePreguntas"
                  onClick={() => toggleSubAccordion(3)}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "rgb(33, 64, 129)",
                    }}
                  >
                    ¿Quién puede acceder al factoring con Primus Capital?
                  </span>
                  <i
                    className={`fas ${
                      subActiveIndex === 3 ? "fa-angle-up" : "fa-angle-down"
                    }`}
                    style={{ marginLeft: "auto" }}
                  ></i>
                </div>
                {subActiveIndex === 3 && (
                  <div className="accordion-contentPreguntas">
                    <p>
                      Empresas y personas naturales que cuenten con al menos un
                      año de experiencia en sus operaciones. Los requisitos
                      específicos pueden variar según las necesidades y la
                      situación particular de cada cliente.
                    </p>
                  </div>
                )}
              </div>
              <div className="accordion-itemPreguntas" style={{ width: "90%" }}>
                <div
                  className="accordion-titlePreguntas"
                  onClick={() => toggleSubAccordion(4)}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "rgb(33, 64, 129)",
                    }}
                  >
                    ¿Cómo contactar con Primus Capital?
                  </span>
                  <i
                    className={`fas ${
                      subActiveIndex === 4 ? "fa-angle-up" : "fa-angle-down"
                    }`}
                    style={{ marginLeft: "auto" }}
                  ></i>
                </div>
                {subActiveIndex === 4 && (
                  <div className="accordion-contentPreguntas">
                    <p>
                      Puede contactar a Primus Capital llenando el formulario
                      Aquí. También puede contactarnos al teléfono +511 500 0504
                      anexo 400, nuestra dirección: Av. Jorge Basadre 233, Piso
                      5, San Isidro, Lima y en nuestras redes sociales.
                    </p>
                  </div>
                )}
              </div>
              <div className="accordion-itemPreguntas" style={{ width: "90%" }}>
                <div
                  className="accordion-titlePreguntas"
                  onClick={() => toggleSubAccordion(5)}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "rgb(33, 64, 129)",
                    }}
                  >
                    ¿Cuál es la diferencia entre realizar una operación de
                    factoring y solicitar un crédito?
                  </span>
                  <i
                    className={`fas ${
                      subActiveIndex === 5 ? "fa-angle-up" : "fa-angle-down"
                    }`}
                    style={{ marginLeft: "auto" }}
                  ></i>
                </div>
                {subActiveIndex === 5 && (
                  <div className="accordion-contentPreguntas">
                    <p>
                      La principal diferencia radica en la naturaleza de las
                      transacciones. En una operación de factoring, se ceden las
                      facturas pendientes de pago a nuestra empresa, obteniendo
                      de manera inmediata el efectivo correspondiente. En la
                      fecha de vencimiento de la factura que fue cedida a Primus
                      Capital, el pago se realiza por parte del deudor. En este
                      caso, la deuda no se reporta a las centrales de riesgos
                      por lo cual el nivel crediticio de tu empresa no se verá
                      afectado. Por otro lado, al solicitar un crédito, se
                      accede a una línea de financiamiento que debe ser devuelta
                      en cuotas acordadas, generalmente con intereses por parte
                      de la empresa que solicitó el crédito, haciendo que la
                      deuda se vea reflejada en las centrales de riesgos y se
                      incrementen las líneas bancarias de tu empresa.
                    </p>
                  </div>
                )}
              </div>
              <div className="accordion-itemPreguntas" style={{ width: "90%" }}>
                <div
                  className="accordion-titlePreguntas"
                  onClick={() => toggleSubAccordion(6)}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "rgb(33, 64, 129)",
                    }}
                  >
                    ¿A qué información puedo acceder desde la Sucursal Virtual
                    siendo cliente?
                  </span>
                  <i
                    className={`fas ${
                      subActiveIndex === 6 ? "fa-angle-up" : "fa-angle-down"
                    }`}
                    style={{ marginLeft: "auto" }}
                  ></i>
                </div>
                {subActiveIndex === 6 && (
                  <div className="accordion-contentPreguntas">
                    <p>
                      Ver detalle del Stock (facturas cedidas a Primus Capital),
                      vencimientos (detalle de vencimiento de las facturas),
                      cancelaciones, cartera vigente y excedentes, datos del
                      ejecutivo que lo atiende, entre otros.
                    </p>
                  </div>
                )}
              </div>
              <div className="accordion-itemPreguntas" style={{ width: "90%" }}>
                <div
                  className="accordion-titlePreguntas"
                  onClick={() => toggleSubAccordion(7)}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "rgb(33, 64, 129)",
                    }}
                  >
                    ¿Cómo se puede tener usuario y clave de cliente?
                  </span>
                  <i
                    className={`fas ${
                      subActiveIndex === 7 ? "fa-angle-up" : "fa-angle-down"
                    }`}
                    style={{ marginLeft: "auto" }}
                  ></i>
                </div>
                {subActiveIndex === 7 && (
                  <div className="accordion-contentPreguntas">
                    <p>
                      Una vez que haya cursado su primer negocio con nosotros,
                      la clave será enviada al correo con el cual fueron
                      registrados en el sistema en un lapso máximo de 24 horas
                      con los datos de usuario y clave que podrá modificar de
                      inmediato apenas ingrese al enlace que le suministraremos.
                      En caso de olvido, la solicitud de nueva clave la haría
                      después a través de su ejecutivo comercial.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="preguntas-image-container">
            <img src={Preguntas} alt="Imagen" />
          </div>
        </div>
      </div>
      {/* ---------CANAL DE DENUNCIAS---------- */}
      <div className="denuncias">
        <h1 className="denuncias-title">Canal de Denuncias</h1>
        <div className="denuncias-text-container">
          <p>
            Cumpliendo con lo establecido en la Ley N° 30424 y el Decreto
            Legislativo N° 1352 y de acuerdo con el Modelo de Prevención de
            Delitos de Primus Capital Perú S.A.C., ponemos a disposición de
            nuestros funcionarios, ejecutivos, clientes, proveedores y del
            público en general, el presente canal de denuncias asociado a la
            responsabilidad penal de las personas jurídicas en los delitos de
            corrupción, lavado de activos, financiamiento del terrorismo, entre
            otros.
          </p>
          <p>
            El canal dispuesto para estos efectos está destinado a recibir
            denuncias sobre hechos que tengan relación con dicho tipo de
            delitos, así como de cualquier otra circunstancia sobre presuntos
            actos irregulares, fraudulentos o ilícitos al interior de la empresa
            a través del siguiente correo electrónico:<span> </span> <a href="oficialdecumplimiento@primuscapital.pe">oficialdecumplimiento@primuscapital.pe</a><span> </span>
             y/o de manera presencial
            acercándose a nuestras oficinas, ubicadas en: Av. Jorge Basadre N°
            233, Piso 5, San Isidro. Primus Capital Perú S.A.C., garantiza la
            confidencialidad de las denuncias recibidas; además de la exhaustiva
            y responsable investigación al respecto.
          </p>
        </div>
      </div>

      {/* -----------DESCARGAS----------      */}
      <div className="descargas">
        <div className="box-descargas">
          <div className="descargas-text-container">
            <p>
            Manual de Prevención de Lavado de Activos y Financiamiento del Terrorismo
            </p>
          </div>
          <div className="descargas-button-container">
            <a
              href={ManualPrevencion}
              download="Manual-Prevencion_LAFDT-PrimusCapitalPeru.pdf"
            >
              <button>Descargar</button>
            </a>
          </div>
        </div>
        <div className="box-descargas">
          <div className="descargas-text-container">
            <p>Manual de Prevención de Delitos </p>
          </div>
          <div className="descargas-button-container">
            <a
              href={ManualPrevencionDelitos}
              download="Manual-Prevencion_Delitos_PrimusCapitalPeru.pdf"
            >
              <button>Descargar</button>
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InformacionDeInteres;
